// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x6Mq77LFaIpcO_zY {
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}

.XKBb1kEuivscJxz5 {
	align-self: flex-end;
	background: var(--lok-color-background-success);
	border-color: var(--lok-color-background-surface-default);
	color: var(--lok-color-text-success);
}

.IPA5DhMqgckXYo3F.IPA5DhMqgckXYo3F {
	max-width: 315px;
	text-align: center;
	font-family: var(--lok-font-family-inter);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/AiModelSelect/AiModelSelect.module.css"],"names":[],"mappings":"AAAA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,oBAAoB;CACpB,+CAA+C;CAC/C,yDAAyD;CACzD,oCAAoC;AACrC;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,yCAAyC;AAC1C","sourcesContent":[".heading {\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.tag {\n\talign-self: flex-end;\n\tbackground: var(--lok-color-background-success);\n\tborder-color: var(--lok-color-background-surface-default);\n\tcolor: var(--lok-color-text-success);\n}\n\n.tooltip.tooltip {\n\tmax-width: 315px;\n\ttext-align: center;\n\tfont-family: var(--lok-font-family-inter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `x6Mq77LFaIpcO_zY`,
	"tag": `XKBb1kEuivscJxz5`,
	"tooltip": `IPA5DhMqgckXYo3F`
};
export default ___CSS_LOADER_EXPORT___;
